<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" (click)="goBack()"></i>

        <span class="my-auto f16 fw-bold me-2"> جستجو و مرور راننده </span>

    </div>

</div>

<form #form="ngForm" (ngSubmit)="searchDrivers(form)" class="rtl w-100 row gx-2 gy-3 gy-md-2 mt-0 mt-md-2 p-2">

    <div class="col-12 col-md-4">

        <input ngModel name="strFullName" type="text" class="form-control" placeholder="نام و نام خانوادگی ">

    </div>

    <div class="col-12 col-md-3">

        <input ngModel name="strMobile" maxlength="11"
            oninput="this.value=this.value.replace(/[^0-9]/g,'');if(this.value != ''){dir='ltr'};if(this.value == ''){dir='rtl'};"
            class="form-control" placeholder="شماره موبایل ">

    </div>

    <div class="form col-12 col-md-3 position-relative">

        <label> نام مدرسه </label>

        <input type="search" name="selectedSchool" [placeholder]="list_Schools.length == 0 ? 'لطفا اندکی صبر کنید' : '' " autocomplete="off" class="form-control" [(ngModel)]="searchT_School" (input)="filterSchool()" />

        <ul class="list-group" style="max-height: 200px;overflow: auto;">

            <li class="list-group-item pointer" *ngFor="let item of filteredSchools" [@fadeAnimation] (click)="iMobileDomain=item.iMobileDomain;filteredSchools=[];searchT_School=item.strComment">{{ item.strComment }}</li>

        </ul>

    </div>

    <div class="col-12 col-md-2 text-end">

        <button class="btn mx-0 mx-md-2 px-5 btn-primary">جستجو</button>

    </div>

</form>

<main class=" rtl px-2">

    <span *ngIf="list_Drivers.length > 0"> تعداد <span class="text-danger fw-bold">{{list_Drivers.length | faNum}}</span> مورد یافت شد </span>

    <div class="row gx-2 mt-1 border border-2 ">

        <div class="col-12 col-md-10 p-3">

            <input type="search" #search (input)="searchBy(search.value)" class="form-control" placeholder="جستجو کنید">

        </div>

        <div class="col-12 text-end col-md-2 p-3" *ngIf="list_Drivers.length > 0">

            <button class="btn btn-success mx-0 mx-md-2" (click)="exportExcel()">
    
                <span> خروجی اکسل </span>
    
                <i class="fa fa-file-excel-o mx-2" aria-hidden="true"></i>
    
            </button>

        </div>

        <div class="table-responsive" style="max-height: 76vh;">

            <table class="table table-striped" id="Export_Excel">

                <thead class="position-sticky top-0 bg-white">

                    <tr class="col-12 text-center">

                        <th> # </th>

                        <th class="col-1"> مشخصات </th>

                        <th> تصویر </th>

                        <th (click)="sortBy(0)" class="pointer">

                            نام و نام خانوادگی

                            <i class="fa fa-sort ms-1" aria-hidden="true"></i>

                        </th>

                        <th> نوع خودرو </th>

                        <th> پلاک خودرو </th>

                        <th (click)="sortBy(1)" class="pointer">

                            شماره موبایل

                            <i class="fa fa-sort ms-1" aria-hidden="true"></i>

                        </th>

                        <th>مدرسه</th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of list_Drivers;let i = index">

                        <th>{{i + 1 | faNum}}</th>
                        <td class="col-1"> <i class="fa fa-address-card-o btn btn-primary fa-lg" aria-hidden="true"
                                (click)="showDetail(item)"></i> </td>
                        <td><img class="rounded-circle" width="50" height="50"
                                src="{{item.strAvatar.trim() != '' ? 'data:image/jpeg;base64,' + item.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}"
                                [alt]="item.strName + item.strFamily"> </td>
                        <td class="col-2">{{item.strFullName | faNum}}</td>
                        <td>{{item.strGPSType_strComment | faNum}}</td>
                        <td>{{formatted_pelak(item.strVehicleNo) | faNum}}</td>
                        <td>{{item.strMobile | faNum}}</td>
                        <td>{{item.strMobileDomain_strComment}}</td>


                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>

<div class="modal fade" id="driver_detail" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false"
    data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-lg">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h6 class="modal-title"> مشخصات راننده </h6>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div class="modal-body">

                <div class="text-center">

                    <img class="rounded-circle" width="150" height="150"
                        src="{{detail.strAvatar != '' ? 'data:image/jpeg;base64,' +  detail.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}"
                        alt="">

                </div>

                <div class="rtl w-100 row gx-2 gy-2 mt-2 ">

                    <div class="col-12 col-md-4">

                        <label> نام و نام خانوادگی </label>

                        <input [ngModel]="detail.strFullName" name="strFullName" type="text" class="form-control">

                    </div>

                    <div class="col-12 col-md-4">

                        <label> شماره همراه </label>

                        <input [ngModel]="(detail.strMobile | faNum )" name="strMobile" type="text"
                            class="form-control">

                    </div>

                    <div class="col-12 col-md-4">

                        <label> نوع خودرو </label>

                        <input [ngModel]="detail.strMobileGroup_strComment" name="strMobileGroup_strComment" type="text"
                            class="form-control">

                    </div>

                    <div class="col-12 col-md-4">

                        <label> مدل خودرو </label>

                        <input [ngModel]="(detail.iYearConstruction | faNum )" name="iYearConstruction" type="text"
                            class="form-control">

                    </div>

                    <div class="col-12 col-md-4">

                        <label> رنگ خودرو </label>

                        <input [ngModel]="detail.strColor" name="iYearConstruction" type="text" class="form-control">

                    </div>

                    <div class="col-12 col-md-4 position-relative">

                        <label for="strAddress"> مدرسه </label>

                        <input [ngModel]="detail.strMobileDomain_strComment" name="strAddress"
                            class="x form-control col-md-10 py-2">

                    </div>


                </div>

                <div class="rtl row gx-2 text-center w-100 mt-2 border border-2 p-2" *ngIf="lstDrivers_Student.length > 0 ">

                    <span class="bg-warning col-12 py-2 rounded fw-bold" > لیست دانش آموزان {{detail?.strFullName | faNum }} </span>

                    <div class="table-responsive" style="max-height: 45vh;">

                        <table class="table table-striped" id="Export_Excel">

                            <thead class="position-sticky top-0 bg-white">

                                <tr class="col-12 text-center">

                                    <th> # </th>

                                    <th> تصویر </th>

                                    <th> موقعیت </th>

                                    <th> جنسیت </th>

                                    <th> نام و نام خانوادگی </th>

                                    <th> مدرسه </th>

                                    <th> فاصله تا مدرسه </th>

                                </tr>

                            </thead>

                            <tbody>

                                <tr class="col-12 text-center" *ngFor="let item of lstDrivers_Student;let i = index">

                                    <td> {{i+1 | faNum}} </td>

                                    <td><img class="rounded-circle" width="50" height="50" src="{{item.strAvatar.trim() != '' ? 'data:image/jpeg;base64,' + item.strAvatar : '../../../../assets/Img/111-1114718_transparent-sleep-icon-png-person-icon-circle-png.jpg' }}" [alt]="item.strName + item.strFamily"> </td>

                                    <td (click)="showOnMap(item)" ><i class="btn btn-primary fa fa-map-marker fa-lg" aria-hidden="true"></i></td>

                                    <td>{{item.strSex_strSexComment}}</td>

                                    <td>{{item.strPassenger_FullName | faNum}}</td>

                                    <td>{{item.strMobileDomain_strComment}}</td>

                                    <td>{{ ( item.fDistance | faNum ) + ' کیلومتر '}}</td>

                                </tr>

                            </tbody>

                        </table>

                    </div>

                </div>

                <div class="rtl mt-2 border border-2 p-2 text-center bg-danger text-white" *ngIf="lstDrivers_Student.length == 0 ">

                    <span> هنوز دانش آموزی به این راننده اختصاص داده نشده است </span>

                </div>

                <div class="mt-2">

                    <button class="btn btn-success px-5 " (click)="calculateKm()"> طول مسیر </button>
 
                </div>

            </div>

        </div>

    </div>

</div>

<div class="modal fade" id="stdLocation" tabindex="-1" aria-labelledby="" aria-hidden="true" data-backdrop="false" data-keyboard="false">

    <div class="modal-dialog modal-dialog-centered modal-xl">

        <div class="modal-content p-1">

            <div class="modal-header dirI">

                <h5 class="modal-title"> موقعیت</h5>

                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>

            </div>

            <div id="map" class="position-sticky w-100 " style="height: 500px;">

                <div class="position-absolute" id="map_tooltip" data-bs-html="true"></div>

            </div>

        </div>

    </div>

</div>

<ng-container *ngIf="isLoading" class="">

    <div class="school_loading">

        <img src="../../../../assets/Img/school_2.gif" alt="loading">

    </div>

</ng-container>